<app-admin-dashboard>
  <p-card header="{{'AdminLoadInvoice.PageTitle' | translate}}">

    <!-- Formulario de Filtros -->
    <form [formGroup]="filterForm">

      <!-- Sección: Filtros Obligatorios -->
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="col-12">
          <h3 class="text-base font-medium text-800 mb-3">
            {{'AdminLoadInvoice.RequiredFilters' | translate}}
          </h3>
        </div>
      </div>

      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-6">
          <label for="profileType" style="font-weight: bolder"
            >Tipo de perfil *</label
          >
          <p-dropdown
            id="profileType"
            [ngModelOptions]="{standalone: true}"
            [options]="profileTypeOptions"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            filterBy="label"
            [showClear]="false"
            [(ngModel)]="selectedProfileType"
            (onChange)="onChangeProfileType($event.value)"
            placeholder="Tipo de perfil"
            class="custom-dropdown"
          >
          </p-dropdown>
        </div>
        <!-- Profile -->
        <div class="field col-12 md:col-6 lg:col-4"
        *ngIf="selectedProfileType == 1 || selectedProfileType == 2"
        >
          <label for="profileId" style="font-weight: bolder">
            {{'AdminLoadInvoice.ProfileLabel' | translate}} *
          </label>
          <p-dropdown
            id="profileId"
            formControlName="profileId"
            [options]="profiles"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            (onChange)="onProfileChange($event.value)"
            placeholder="{{'AdminLoadInvoice.ProfilePlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>

        <div class="field col-12 md:col-6 lg:col-4"
        *ngIf="(selectedProfileType == 5 || selectedProfileType == 6)
        ">
          <label for="companyId" style="font-weight: bolder">
            {{'AdminLoadInvoice.CompanyLabel' | translate}} *
          </label>
          <p-dropdown
            id="companyId"
            formControlName="companyId"
            [options]="companies"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            (onChange)="onProfileChange($event.value)"
            placeholder="{{'AdminLoadInvoice.CompanyPlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>

        <!-- Fecha Inicial -->
        <div class="field col-12 md:col-6 lg:col-4">
          <label for="startDate" style="font-weight: bolder">
            {{'AdminLoadInvoice.StartDateLabel' | translate}} *
          </label>
          <p-calendar
            id="startDate"
            formControlName="startDate"
            (onSelect)="onDateChange()"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2020:2030"
            placeholder="{{'AdminLoadInvoice.StartDatePlaceholder' | translate}}"
            class="custom-calendar">
          </p-calendar>
        </div>

        <!-- Fecha Final -->
        <div class="field col-12 md:col-6 lg:col-4">
          <label for="endDate" style="font-weight: bolder">
            {{'AdminLoadInvoice.EndDateLabel' | translate}} *
          </label>
          <p-calendar
            id="endDate"
            formControlName="endDate"
            (onSelect)="onDateChange()"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2020:2030"
            [minDate]="filterForm.get('startDate')?.value"
            placeholder="{{'AdminLoadInvoice.EndDatePlaceholder' | translate}}"
            class="custom-calendar">
          </p-calendar>
        </div>
      </div>

      <!-- Sección: Filtros Opcionales -->
      <div class="p-fluid formgrid mr-2 ml-2 grid mt-3">
        <div class="col-12">
          <h3 class="text-base font-medium text-800 mb-3">
            {{'AdminLoadInvoice.OptionalFilters' | translate}}
          </h3>
        </div>
      </div>

      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <!-- Importador -->
        <div class="field col-12 md:col-6 lg:col-4">
          <label for="importerId">
            {{'AdminLoadInvoice.ImporterLabel' | translate}}
          </label>
          <p-dropdown
            id="importerId"
            formControlName="importerId"
            [options]="loadProfiles.importers"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            placeholder="{{'AdminLoadInvoice.ImporterPlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>

        <!-- Exportador -->
        <div class="field col-12 md:col-6 lg:col-4">
          <label for="exporterId">
            {{'AdminLoadInvoice.ExporterLabel' | translate}}
          </label>
          <p-dropdown
            id="exporterId"
            formControlName="exporterId"
            [options]="loadProfiles.exporters"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            placeholder="{{'AdminLoadInvoice.ExporterPlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>

        <!-- Forwarder -->
        <div class="field col-12 md:col-6 lg:col-4">
          <label for="forwarderName">
            {{'AdminLoadInvoice.ForwarderLabel' | translate}}
          </label>
          <p-dropdown
            id="forwarderName"
            formControlName="forwarderId"
            optionValue="id"
            optionLabel="companyName"
            [options]="loadProfiles.forwarders"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            placeholder="{{'AdminLoadInvoice.ForwarderPlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>
      </div>

      <!-- Botones de Acción -->
      <div class="p-fluid formgrid mr-2 ml-2 grid mt-2">
        <div class="col-12 md:col-6 lg:col-3">
          <p-button
            type="button"
            icon="pi pi-search"
            label="{{'AdminLoadInvoice.SearchButton' | translate}}"
            (onClick)="searchDeliveries()"
            [loading]="loading"
            [disabled]="!canSearch"
            styleClass="p-button-primary"
            class="custom-text-button">
          </p-button>
        </div>

        <div class="col-12 md:col-6 lg:col-3">
          <p-button
            type="button"
            icon="pi pi-filter-slash"
            label="{{'AdminLoadInvoice.ClearButton' | translate}}"
            (onClick)="clearFilters()"
            styleClass="p-button-outlined"
            class="custom-text-button">
          </p-button>
        </div>
      </div>
    </form>

    <!-- Tabla de Resultados -->
    <div class="p-fluid formgrid mr-2 ml-2 grid mt-4" *ngIf="showResults">
      <div class="col-12">
        <div class="flex justify-content-between align-items-center mb-3">
          <h3 class="text-base font-medium text-800 m-0">
            {{'AdminLoadInvoice.ResultsTitle' | translate}}
          </h3>
          <span class="detail-text">
            {{'AdminLoadInvoice.SelectedCount' | translate}}:
            <strong>{{selectedDeliveries.length}}</strong> / {{deliveries.length}}
          </span>
        </div>

        <p-table
          [value]="deliveries"
          [(selection)]="selectedDeliveries"
          dataKey="deliveryId"
          [loading]="loading"
          [paginator]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[30, 50, 100]"
          responsiveLayout="stack"
          [totalRecords]="totalCount"
          [breakpoint]="'600px'"
          (onHeaderCheckboxToggle)="onSelectionChange($event)"
          (onLazyLoad)="getAvailableDeliveriesEvent($event)"
          [lazy]="true"
          class="custom-table bg-header">

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoice.Table.ContainerHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'AdminLoadInvoice.Table.ETDHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoice.Table.DepartureHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoice.Table.DestinationHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoice.Table.ImporterHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoice.Table.ExporterHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoice.Table.ForwarderHeader' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-delivery>
            <tr>
              <td>
                <p-tableCheckbox [value]="delivery"></p-tableCheckbox>
              </td>
              <td>
                <div class="flex align-items-center">
                  <span class="font-bold">{{delivery.containerNumber}}</span>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  {{delivery.etd ? (delivery.etd | date: 'dd/MM/yyyy') : 'N.A.'}}
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  {{delivery.departureName || 'N.A.'}}
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  {{delivery.destinationName || 'N.A.'}}
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  {{delivery.importerName || 'N.A.'}}
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  {{delivery.exporterName || 'N.A.'}}
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  {{delivery.forwarderCompanyName || 'N.A.'}}
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" class="text-center">
                {{'AdminLoadInvoice.NoResultsMessage' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Botón de Continuar -->
    <div class="p-fluid formgrid mr-2 ml-2 grid mt-3" *ngIf="selectedDeliveries.length > 0">
      <div class="col-12 md:col-6 lg:col-4">
        <p-button
          type="button"
          icon="pi pi-arrow-right"
          label="{{'AdminLoadInvoice.ContinueButton' | translate}}"
          (onClick)="continueWithInvoicing()"
          styleClass="p-button-primary"
          class="custom-text-button">
        </p-button>
      </div>
    </div>

  </p-card>
</app-admin-dashboard>
